import { CommonModule, DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { consents } from "src/app/app.component";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";

type NumRange = 0 | 1 | 2 | 3 | null;
@Component({
  selector: "app-modal-politica-co",
  imports: [CommonModule, MatButtonModule, MatIconModule, MatSlideToggleModule],
  templateUrl: "./cookie-consent.component.html",
  styleUrls: ["./cookie-consent.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentComponent implements OnInit {
  @Input() config: consents;
  public dropdownState: NumRange;
  public test: NumRange;
  private constantesGlobales: any;
  public siteName: string;
  public imagenLogo: string;
  public step: string = "info";
  public selectorName: string;
  public publicidadValue: boolean = true;
  public rendimientoValue: boolean = false;

  @ViewChild("slidePublicidad") public slidePublicidad: ElementRef;
  @ViewChild("slideRendimiento") public slideRendimiento: ElementRef;

  @Output() reject = new EventEmitter();
  @Output() accept = new EventEmitter();
  @Output() reconfigure = new EventEmitter();

  constructor(
    private configService: ConfigService,
    private elementRef: ElementRef,
    private platformService: PlatformService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    // this.step = 'info';
  }

  ngOnInit() {
    if (this.platformService.isBrowser()) {
      this.renderer2.setStyle(this.document.body, "overflow", "hidden");
    }
    if (this.config) {
      this.publicidadValue = this.config.publicidad;
      this.rendimientoValue = this.config.rendimiento;
    }
    this.constantesGlobales = this.configService.getConstantesGlobales();
    this.selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    this.siteName = this.constantesGlobales.siteName.replace(".", "");
    this.configService.getConfigPrensa().subscribe((resultConfig) => {
      if (resultConfig) {
        const configBloque = resultConfig.general[this.selectorName];
        if (configBloque) {
          const colorBotones = this.hexToHSL(configBloque.color_botones);
          this.elementRef.nativeElement.style.setProperty("--primary-color", this.HSLtoStr(colorBotones));
          const colorBotonesClaro = colorBotones;
          colorBotonesClaro["l"] += 10;
          this.elementRef.nativeElement.style.setProperty("--primary-color-lighter", this.HSLtoStr(colorBotonesClaro));
        }
        const configBloqueLogo = resultConfig.general["app-logo-menu"];

        const fondoDegradado = configBloqueLogo.fondo_degradado === "true";
        this.imagenLogo = configBloqueLogo.logo;
        const colorFondo = configBloqueLogo.color_fondo;
        if (fondoDegradado) {
          const colorDegradado = configBloqueLogo.color_degradado;
          this.elementRef.nativeElement.style.setProperty("--background-image-url", "linear-gradient(" + colorFondo + ", " + colorDegradado + ")");
        } else {
          this.elementRef.nativeElement.style.setProperty("--background-image-url", colorFondo);
        }
        if (configBloqueLogo.imagen_fondo_activo === "true") {
          this.elementRef.nativeElement.style.setProperty("--background-image-url", "url(" + configBloqueLogo.imagen_fondo + ")");
        }
      }
    });
  }

  goConfig(): void {
    this.step = "config";
  }

  goSub() {
    this.step = "sub";
  }

  goInfo() {
    this.step = "info";
  }

  onReject() {
    this.reject.emit();
  }

  onAccept() {
    this.accept.emit();
  }
  onAcceptConfig() {
    let changes = false;
    if (this.config) {
      if (this.slideRendimiento["checked"] !== this.config.rendimiento || this.slidePublicidad["checked"] !== this.config.publicidad) {
        changes = true;
      }
    }
    const response = {
      rendimiento: this.slideRendimiento["checked"],
      publicidad: this.slidePublicidad["checked"],
      changes: changes,
    };

    this.accept.emit(response);
  }

  toggleDropdown(index): void {
    if (this.dropdownState === index) {
      this.dropdownState = null;
      return;
    }
    this.dropdownState = index;
  }

  hexToHSL(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h,
      l,
      s = (max + min) / 2;
    if (max == min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
      if (h < 0) {
        h += 360;
      }
    }
    const HSL = new Object();
    HSL["h"] = h;
    HSL["s"] = s * 100;
    HSL["l"] = l * 100;
    return HSL;
  }

  HSLtoStr(HSL: any): string {
    const str: string = `hsl(${Math.round(HSL["h"])}, ${Math.round(HSL["s"])}%, ${Math.round(HSL["l"])}%)`;
    return str;
  }
}
